// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_Rp","refLinkDesktop":"e_Sp","titleFont":"e_Tp"};